import axios from "axios";

export const state = {
    audits: [],
};

export const getters = {
    audits: state => state.audits,
};

export const mutations = {
    setAudits(audits, newValue) { state.audits = newValue},
};

export const actions = {
    async fetchAudits({ commit }) {
        await axios.get('/audits').then(res => {
            commit('setAudits', res.data.audits)
        })
    },
    async filterAudits({commit}, {user_id,datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("user_id", user_id);
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filteraudits";
        await axios.post(url, formData).then((response) => {
            commit('setAudits', response.data.audits)
        })
    },
};
